// Declarative registry of supported UI languages — the single source of truth for the
// language selector, the i18n config, dayjs locale switching, Element Plus locale, and
// the <html lang> attribute. Adding a new language = one row here + a new src/locales/<code>.json.
//
// `dayjs` and `elementPlus` are intentionally separate fields because the third-party
// locale identifiers differ from our `code`: dayjs ships Simplified Chinese as `zh`
// (already imported in src/plugins/dayjs.js), while Element Plus ships it as `zh-cn`.
export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English', short: 'EN', dayjs: 'en', elementPlus: 'en' },
  { code: 'es', label: 'Español', short: 'ES', dayjs: 'es', elementPlus: 'es' },
  // zh is temporarily hidden from the selector — re-add this row to bring it back
  // (zh.json messages + EP/dayjs locales stay wired, so it's a one-line restore).
  // { code: 'zh', label: '简体中文', short: 'ZH', dayjs: 'zh', elementPlus: 'zh-cn' },
];

export const DEFAULT_LOCALE = 'en';

export const SUPPORTED_CODES = SUPPORTED_LOCALES.map((l) => l.code);

export const getLocale = (code) =>
  SUPPORTED_LOCALES.find((l) => l.code === code) ||
  SUPPORTED_LOCALES.find((l) => l.code === DEFAULT_LOCALE);
